import React from 'react';
import PropTypes from 'prop-types';
import cn from 'classnames';
import Tooltip from '@omilia/tooltip';

import './style.scss';

const MapToIntentIcon = ({ onOpen, isPublic }) => (
  <Tooltip
    content={
      <React.Fragment>
        {isPublic ? '+ Map to' : 'No public'}
        <br />
        {isPublic ? 'Intent' : 'entity'}
      </React.Fragment>
    }
  >
    <button
      className="icon-map-to-intent"
      data-place="left"
      data-test="map-to-intent-button"
      styleName={cn('icon', {
        'no-public': !isPublic,
      })}
      type="button"
      onClick={onOpen}
    />
  </Tooltip>
);

MapToIntentIcon.propTypes = {
  isPublic: PropTypes.bool,
  onOpen: PropTypes.func,
};

export default MapToIntentIcon;
